<template>
  <div class="decision-data">
    <p>
      Decyzja:
      <strong>{{ documentIndex.currentDecision.name }}</strong>
    </p>

    <div v-if="documentIndex.currentDecision.positive">
      <p v-if="documentIndex.currentDecision.data.amount">
        Kwota: <strong> {{ documentIndex.currentDecision.data.amount }} zł </strong>
      </p>

      <div v-if="scholarshipFormsRanges.length && decisionWithRanges">
        <div><p>Forma świadczenia:</p></div>

        <ul class="dashed">
          <li v-for="(dateRange, index) in scholarshipFormsRanges" :key="'dateRange_' + index">
            <strong>
              {{ dateRangeTranslation(dateRange.type) }}

              <span v-if="dateRange.amount">({{ dateRange.amount }} zł)</span>:

              {{ dateRange.startDate | moment('DD-MM-YYYY') }} -
              {{ dateRange.endDate | moment('DD-MM-YYYY') }}
            </strong>
          </li>
        </ul>
      </div>

      <div v-if="withdrawalPeriods.length">
        <p>Okresy cofnięcia pomocy:</p>

        <ul style="padding-left: 20px">
          <li v-for="(dateRange, index) in withdrawalPeriods" :key="'dateRange_' + index">
            <strong>
              {{ dateRange.startDate | moment('DD-MM-YYYY') }} -
              {{ dateRange.endDate | moment('DD-MM-YYYY') }}
            </strong>
          </li>
        </ul>
      </div>

      <div v-if="holdPeriods.length">
        <p>Okresy wstrzymania pomocy:</p>

        <ul style="padding-left: 20px">
          <li v-for="(dateRange, index) in holdPeriods" :key="'dateRange_' + index">
            <strong>
              {{ dateRange.startDate | moment('DD-MM-YYYY') }} -
              {{ dateRange.endDate | moment('DD-MM-YYYY') }}
            </strong>
          </li>
        </ul>
      </div>

      <p v-if="decisionWithRanges">
        Okres obowiązywania decyzji:
        <strong>
          {{ documentIndex.currentDecision.startDate | moment('DD-MM-YYYY') }} -
          {{ documentIndex.currentDecision.endDate | moment('DD-MM-YYYY') }}
        </strong>
      </p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import { DecisionCalculationTypeTranslation, DecisionCalculationType } from '@/enums/decisionCalculationType';
import { PublicSettings } from '@/enums/publicSettings.enum';

// @vuese
// Wyświetla dane decyzji dokumentu
// @group Document
export default {
  props: {
    // Dokument z indeksu
    documentIndex: { type: Object, required: true }
  },

  computed: {
    ...mapState({
      decisionWithRanges: state => state.setting.settings[PublicSettings.DECISION_WITH_RANGES]?.value === 'true'
    }),
    scholarshipFormsRanges() {
      return this.documentIndex.currentDecision?.dateRanges.filter(
        dataRange =>
          dataRange.type === DecisionCalculationType.AMOUNT || dataRange.type === DecisionCalculationType.INVOICE
      );
    },

    withdrawalPeriods() {
      return this.documentIndex.currentDecision?.dateRanges.filter(
        dataRange => dataRange.type === DecisionCalculationType.WITHDRAWAL
      );
    },
    holdPeriods() {
      return this.documentIndex.currentDecision?.dateRanges.filter(
        dataRange => dataRange.type === DecisionCalculationType.HOLD
      );
    }
  },

  methods: {
    // Tłumaczenie typu przedziału dat decyzji
    dateRangeTranslation(code) {
      return DecisionCalculationTypeTranslation[code];
    }
  }
};
</script>
